// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__31ESE","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2dd8H"};